/**
 *
 *
 * @param name
 * @param type
 * @param content
 * @param roles
 * @returns {Promise<void>}
 */
import {apiGET, apiPOST, apiGETPaginated} from "./RequestsCore";

/**
 * Returns all the existing roles in the app, without pagination.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getAllPaginatedBurofaxes(filters) {
    return await apiGETPaginated('/api/burofax', filters);
}

/**
 * Returns all the existing roles in the app, without pagination.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getAllBurofaxes() {
    return await apiGET('/api/burofax');
}
/**
 * Returns all the existing roles in the app, without pagination.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getBurofax(burofax_id) {
    return await apiGET('/api/burofax/' + burofax_id);
}
/**
 * Returns all the existing roles in the app, without pagination.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function downloadBurofax(burofax_id) {
    return await apiGET('/api/burofax/' + burofax_id + '/download');
}
/**
 * create new burofax
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function createBurofax(expedient_id, template_id, data) {
    return await apiPOST('/api/expedient/' + expedient_id + '/template/' + template_id + '/burofax', data);
}
